module.exports = __webpack_public_path__ + "img/phone.b3ec4556.svg";